import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPatch } from '../../../utils/axios';
import * as actions from './actions';

function* fetchOrders({ payload }) {
  try {
    const { filters = {} } = payload;

    // Build query parameters
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.email) params.append('email', filters.email);
    if (filters.order_id) params.append('order_id', filters.order_id);
    if (filters.page) params.append('page', filters.page);
    if (filters.page_size) params.append('page_size', filters.page_size);

    const queryString = params.toString();
    const url = queryString ? `/orders/?${queryString}` : '/orders/';

    const result = yield call(AxiosCall, url);
    yield put(actions.fetchOrdersSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchOrdersFailure(error));
  }
}

function* updateOrderStatus({ payload }) {
  try {
    const { orderId, status } = payload;
    const result = yield call(
      AxiosPatch,
      `/orders/${orderId}/update_status/`,
      { status }
    );
    yield put(actions.updateOrderStatusSuccess(result.data));
  } catch (error) {
    yield put(actions.updateOrderStatusFailure(error));
  }
}

export default function* ordersSaga() {
  yield all([
    takeLatest(actions.FETCH_ORDERS.REQUEST, fetchOrders),
    takeLatest(actions.UPDATE_ORDER_STATUS.REQUEST, updateOrderStatus),
  ]);
}
